import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { useRef, useEffect } from 'react';
import { useSalesforceBot } from '../../../hooks/useSalesforceBot/useSalesforceBot.js';
import '../../Atoms/Button/Button.js';
import '../../Atoms/Checkbox/Checkbox.js';
import 'clsx';
import { Text } from '../../Atoms/Text/Text.js';
import '../../Atoms/Device/DeviceProvider.js';
import '../../Atoms/EmployeeBadge/EmployeeBadge.js';
import '../../Atoms/FeatureFlag/FeatureFlag.js';
import 'wretch';
import 'wretch/addons/queryString';
import '../../../utils/mParticle/mParticle.js';
import 'fromentries';
import { generateSupportUrl } from '../../../utils/generateSupportUrl/index.js';
import '../../Atoms/Icon/generated/IconAdd.js';
import '../../Atoms/Icon/generated/IconAddFilled.js';
import '../../Atoms/Icon/generated/IconAddOutline.js';
import '../../Atoms/Icon/generated/IconAddUser.js';
import '../../Atoms/Icon/generated/IconAddressBook.js';
import '../../Atoms/Icon/generated/IconAllTreatments.js';
import '../../Atoms/Icon/generated/IconArrowBack.js';
import '../../Atoms/Icon/generated/IconArrowForward.js';
import '../../Atoms/Icon/generated/IconBadgeCheck.js';
import '../../Atoms/Icon/generated/IconBeard.js';
import '../../Atoms/Icon/generated/IconBody.js';
import '../../Atoms/Icon/generated/IconCake.js';
import '../../Atoms/Icon/generated/IconCalendar.js';
import '../../Atoms/Icon/generated/IconCalendarAdd.js';
import '../../Atoms/Icon/generated/IconCalendarDelete.js';
import '../../Atoms/Icon/generated/IconCard.js';
import '../../Atoms/Icon/generated/IconCash.js';
import '../../Atoms/Icon/generated/IconCaution.js';
import { IconChat } from '../../Atoms/Icon/generated/IconChat.js';
import '../../Atoms/Icon/generated/IconCheckFilled.js';
import '../../Atoms/Icon/generated/IconCheckOutline.js';
import '../../Atoms/Icon/generated/IconChecked.js';
import '../../Atoms/Icon/generated/IconChevronDown.js';
import '../../Atoms/Icon/generated/IconChevronLeft.js';
import '../../Atoms/Icon/generated/IconChevronLeftOutline.js';
import '../../Atoms/Icon/generated/IconChevronRight.js';
import '../../Atoms/Icon/generated/IconChevronRightOutline.js';
import '../../Atoms/Icon/generated/IconChevronUp.js';
import '../../Atoms/Icon/generated/IconClose.js';
import '../../Atoms/Icon/generated/IconCloseOutline.js';
import '../../Atoms/Icon/generated/IconComment.js';
import '../../Atoms/Icon/generated/IconCompass.js';
import '../../Atoms/Icon/generated/IconConfirmOrDeny.js';
import '../../Atoms/Icon/generated/IconCopy.js';
import '../../Atoms/Icon/generated/IconDiscountFilled.js';
import '../../Atoms/Icon/generated/IconDiscountOutline.js';
import '../../Atoms/Icon/generated/IconEdit.js';
import '../../Atoms/Icon/generated/IconEmail.js';
import '../../Atoms/Icon/generated/IconExpand.js';
import '../../Atoms/Icon/generated/IconExternal.js';
import '../../Atoms/Icon/generated/IconFace.js';
import '../../Atoms/Icon/generated/IconFilter.js';
import '../../Atoms/Icon/generated/IconGift.js';
import '../../Atoms/Icon/generated/IconHair.js';
import '../../Atoms/Icon/generated/IconHairRemoval.js';
import '../../Atoms/Icon/generated/IconHappy.js';
import '../../Atoms/Icon/generated/IconHeartFilled.js';
import '../../Atoms/Icon/generated/IconHeartOutlined.js';
import { IconHelp } from '../../Atoms/Icon/generated/IconHelp.js';
import '../../Atoms/Icon/generated/IconHide.js';
import '../../Atoms/Icon/generated/IconHighlights.js';
import '../../Atoms/Icon/generated/IconHome.js';
import '../../Atoms/Icon/generated/IconHomebasedVenue.js';
import '../../Atoms/Icon/generated/IconImage.js';
import '../../Atoms/Icon/generated/IconInfoOutline.js';
import '../../Atoms/Icon/generated/IconLegal.js';
import '../../Atoms/Icon/generated/IconLocation.js';
import '../../Atoms/Icon/generated/IconLock.js';
import '../../Atoms/Icon/generated/IconLogOut.js';
import '../../Atoms/Icon/generated/IconMale.js';
import '../../Atoms/Icon/generated/IconMassage.js';
import '../../Atoms/Icon/generated/IconMedicalDental.js';
import '../../Atoms/Icon/generated/IconMinusOutline.js';
import '../../Atoms/Icon/generated/IconMobileVenue.js';
import '../../Atoms/Icon/generated/IconMoney.js';
import '../../Atoms/Icon/generated/IconNails.js';
import '../../Atoms/Icon/generated/IconNewVenue.js';
import '../../Atoms/Icon/generated/IconNotes.js';
import '../../Atoms/Icon/generated/IconOnMap.js';
import '../../Atoms/Icon/generated/IconOptions.js';
import '../../Atoms/Icon/generated/IconPhone.js';
import '../../Atoms/Icon/generated/IconPin.js';
import '../../Atoms/Icon/generated/IconPinOutline.js';
import '../../Atoms/Icon/generated/IconPresentBox.js';
import '../../Atoms/Icon/generated/IconProfile.js';
import '../../Atoms/Icon/generated/IconReceipt.js';
import '../../Atoms/Icon/generated/IconSearch.js';
import '../../Atoms/Icon/generated/IconSecure.js';
import '../../Atoms/Icon/generated/IconSettings.js';
import '../../Atoms/Icon/generated/IconSort.js';
import '../../Atoms/Icon/generated/IconSpa.js';
import '../../Atoms/Icon/generated/IconStarFilled.js';
import '../../Atoms/Icon/generated/IconStarOutline.js';
import '../../Atoms/Icon/generated/IconSupport.js';
import '../../Atoms/Icon/generated/IconTeam.js';
import '../../Atoms/Icon/generated/IconTime.js';
import '../../Atoms/Icon/generated/IconTreatwellLogo.js';
import '../../Atoms/Icon/generated/IconUnisex.js';
import '../../Atoms/Icon/generated/IconUser.js';
import '../../Atoms/Icon/generated/IconUserDetails.js';
import '../../Atoms/Icon/generated/IconVenue.js';
import '../../Atoms/Icon/generated/IconView.js';
import '../../Atoms/Icon/generated/IconVoucher.js';
import '../../Atoms/Icon/generated/IconWallet.js';
import '../../Atoms/Icon/generated/IconWarningFilled.js';
import '../../Atoms/Icon/generated/IconWarningOutline.js';
import '../../Atoms/Icon/generated/IconWebsite.js';
import '../../Atoms/IconBadge/IconBadge.js';
import '../../Atoms/Input/Input.js';
import '../../Layout/Box/Box.js';
import { Inline } from '../../Layout/Inline/Inline.js';
import { Stack } from '../../Layout/Stack/Stack.js';
import '../../Atoms/Radio/Radio.js';
import '@treatwell/design-tokens';
import '../../Atoms/VisuallyHidden/VisuallyHidden.js';
import '../../Atoms/Textarea/Textarea.js';
import '../../Atoms/TreatmentTypeBadge/TreatmentTypeBadge.js';
import { useViewport } from '../../Atoms/Viewport/useViewport.js';
import { LinkButton } from '../../Atoms/LinkButton/LinkButton.js';
import { Modal } from '../Modal/Modal.js';
import { useModal } from '../Modal/useModal.js';
import { useNotify } from '../Toast/ToastHook.js';
import 'react-dom';
import '../Toast/Toast.js';
import '../Toast/ToastContext.js';
import styles from './SupportFooter.module.css.js';
import { MediaObject } from '../MediaObject/MediaObject.js';

const SupportFooter = ({ botProps, defaultOpen, layout = 'inline', loginUrl = '/protected-action/?route=/account?chat', onChatOpen, onChatClose, getTokens, onHandleBotError, preChat, strings, userAuthenticated, }) => {
    const chatOpened = useRef(false);
    const handleChatOpen = (conversationId) => {
        chatOpened.current = true;
        onChatOpen && onChatOpen(conversationId);
    };
    const { loadBot, launchChat, isReady, isLoading } = useSalesforceBot({
        onChatOpen: handleChatOpen,
        onChatClose,
        getTokens,
        initialPrechat: preChat,
        ...botProps,
    });
    const { notifyError } = useNotify();
    const { modalProps, openModal } = useModal({
        width: 650,
    });
    const isMobile = useViewport({ device: 'mobile' });
    const supportUrl = generateSupportUrl(botProps.locale);
    useEffect(() => {
        if (userAuthenticated) {
            loadBot().catch((error) => onHandleBotError(error));
        }
    }, [userAuthenticated, loadBot, onHandleBotError]);
    useEffect(() => {
        if (defaultOpen && isReady && !chatOpened.current) {
            launchChat(preChat)
                .then(() => (chatOpened.current = true))
                .catch((error) => onHandleBotError(error));
        }
    }, [defaultOpen, isReady, launchChat, onHandleBotError, preChat]);
    const handleChatClick = () => {
        if (!userAuthenticated) {
            openModal();
            return;
        }
        if (isLoading || !isReady) {
            notifyError(strings.genericError);
            return;
        }
        try {
            launchChat(preChat);
        }
        catch {
            notifyError(strings.genericError);
        }
    };
    const footerItems = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("a", { href: supportUrl, className: styles.footerItem, children: jsxRuntimeExports.jsxs(MediaObject, { space: layout === 'stack' ? 'md' : 'xs', align: "center", children: [jsxRuntimeExports.jsx(IconHelp, { size: 24 }), jsxRuntimeExports.jsx(Text, { type: isMobile ? 'caption' : 'bodyHeavy', children: strings.helpCentre })] }) }), jsxRuntimeExports.jsx("button", { className: `${styles.footerItem} ${styles.button}`, onClick: handleChatClick, disabled: userAuthenticated && (isLoading || !isReady), children: jsxRuntimeExports.jsxs(MediaObject, { space: layout === 'stack' ? 'md' : 'xs', align: "center", children: [jsxRuntimeExports.jsx(IconChat, { size: 24 }), jsxRuntimeExports.jsx(Text, { type: isMobile ? 'caption' : 'bodyHeavy', children: strings.chatSupport })] }) })] }));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [layout === 'stack' ? (jsxRuntimeExports.jsx(Stack, { space: "lg", children: footerItems })) : (jsxRuntimeExports.jsx(Inline, { space: "xl", align: "center", children: footerItems })), strings.modal && (jsxRuntimeExports.jsxs(Modal, { className: styles.modal, ...modalProps, children: [jsxRuntimeExports.jsx(Modal.Header, { closeLabel: "Close" }), jsxRuntimeExports.jsx(Modal.Body, { children: jsxRuntimeExports.jsxs(Stack, { space: "xxl", align: "center", children: [jsxRuntimeExports.jsxs(Stack, { space: "md", align: "center", justify: "center", children: [jsxRuntimeExports.jsx(Text, { type: "xlHeader", children: strings.modal.title }), jsxRuntimeExports.jsx(Text, { type: "body", children: strings.modal.body })] }), jsxRuntimeExports.jsx(LinkButton, { className: styles.loginButton, buttonStyle: "primary", size: "lg", fullWidth: true, href: loginUrl, children: strings.modal.cta })] }) })] }))] }));
};

export { SupportFooter };
//# sourceMappingURL=SupportFooter.js.map
